import { createSlice } from '@reduxjs/toolkit';
import api from '../services/api';
import { updateFavoriteReducer } from './reducers';
import { FavoriteAction, FavoriteArticleState, FavoritesSliceState } from './types';

const initialState: FavoritesSliceState = {
  articles: {},
};

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState: initialState,
  reducers: {
    updateFavoriteReducer,
  },
  extraReducers: (builder) => {
    builder.addMatcher(api.endpoints.updateFavorite.matchFulfilled, updateFavoriteReducer);
    builder.addMatcher(api.endpoints.updateFavorite.matchRejected, 
      (state, action) => updateFavoriteReducer(state, { 
        type: action.type, 
        payload: action.payload as any 
      } as FavoriteAction));
      
    builder.addMatcher(api.endpoints.checkIsFavorite.matchFulfilled, updateFavoriteReducer);
    builder.addMatcher(api.endpoints.checkIsFavorite.matchRejected, 
      (state, action) => updateFavoriteReducer(state, { 
        type: action.type, 
        payload: action.payload as any 
      } as FavoriteAction));
  },
});

const getArticleState = (state: FavoritesSliceState, contentId: string): FavoriteArticleState | null => {
  return (state && state.articles[contentId]) ?? null;
};

export default favoritesSlice;

export const actions = favoritesSlice.actions;
export const selectors = {
  getArticleState,
};
